module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "90%"
    },
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by"), _c('br'), _vm._v("Grub Street"), _c('br'), _vm._v("4 Rainham Close"), _c('br'), _vm._v("London"), _c('br'), _vm._v("SW11 6SS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Copyright © Grub Street 2015"), _c('br'), _vm._v("Copyright text © Richard Pike 2015")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("A CIP record for this title is available from the British Library")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("ISBN-13: 9-781-909808-22-5")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Digital ISBN: 9-781-910690-86-4")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Design by Sarah Baldwin"), _c('br'), _vm._v("Edited by Natalie Parker")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Printed and bound by Finidr, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grub Street Publishing only uses FSC (Forest Stewardship Council) paper for its books.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04983aad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 63
// module chunks = 0